// # Admin Secured Routes - Administration Tools and Feedback Management
import React from 'react';
import { Routes, Route, useLocation, Navigate, useParams } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';

// # Import admin tools
import UserManagement from '../../roles/admin/admin_tools/user_manage/user_management';
import Analytics from '../../roles/admin/admin_tools/analytics';
import FinancialSystem from '../../roles/admin/admin_tools/financial_system';
import MasterDatabase from '../../roles/admin/admin_tools/master_database';
import SubscriptionManagement from '../../roles/admin/admin_tools/subscriptions/subscription_management';

// # Import subscription management components
import Subscriptions from '../../roles/admin/admin_tools/subscriptions/subscriptions';
import SubscriptionControls from '../../roles/admin/admin_tools/subscriptions/subscription_controls';
import SpecialSubscription from '../../roles/admin/admin_tools/subscriptions/special_subscription';
import SubscriptionLogs from '../../roles/admin/admin_tools/subscriptions/subsc_log';
import Pricing from '../../roles/admin/admin_tools/subscriptions/pricing';

// # Import user management components
import Users from '../../roles/admin/admin_tools/user_manage/users';
import AdminsTutors from '../../roles/admin/admin_tools/user_manage/admins_tutors';
import OurMentees from '../../roles/admin/admin_tools/user_manage/our_mentees';
import UsersControl from '../../roles/admin/admin_tools/user_manage/users_control';
import UserHonors from '../../roles/admin/admin_tools/user_manage/user_honors';

// # Import feedback management
import AdminFeedback from '../../systems/feedbacks/feedback_admin';
import SupportRequests from '../../systems/support/support_requests';
import AdminReview from '../../systems/reviews/admin_review';

// # Import analytics components
import GrowthAnalytics from '../../roles/admin/admin_tools/analytics/growth_analytics';
import ActivityAnalytics from '../../roles/admin/admin_tools/analytics/activity_analytics';
import HeatMap from '../../roles/admin/admin_tools/analytics/heat_map';
import SubscriptionAnalytics from '../../roles/admin/admin_tools/analytics/subscription_analytics';
import TechnicalAnalytics from '../../roles/admin/admin_tools/analytics/technical_analytics';
import AuthAnalytics from '../../roles/admin/admin_tools/analytics/auth_analytics';

// # Import financial components
import SalaryManagement from '../../roles/admin/admin_tools/finance/salaries/salary';
import ExpensesTracking from '../../roles/admin/admin_tools/finance/expenses/expenses';
import RevenueAnalytics from '../../roles/admin/admin_tools/finance/revenues/net_revenue';
import PaymentProcessing from '../../roles/admin/admin_tools/finance/payments/payments';
import Bank from '../../roles/admin/admin_tools/finance/banco/bank';
import BankAccount from '../../roles/admin/admin_tools/finance/banco/bancount';
import RegisterPayment from '../../roles/admin/admin_tools/finance/payments/register_payment';
import PaymentHistory from '../../roles/admin/admin_tools/finance/payments/pay_history';
import PaymentAnalytics from '../../roles/admin/admin_tools/finance/payments/pay_analytics';
import RegisterExpense from '../../roles/admin/admin_tools/finance/expenses/register_expense';
import ExpenseHistory from '../../roles/admin/admin_tools/finance/expenses/expense_history';
import ExpenseAnalytics from '../../roles/admin/admin_tools/finance/expenses/expense_analytics';
import BudgetAccount from '../../roles/admin/admin_tools/finance/banco/budget';
import BancoTutors from '../../roles/admin/admin_tools/finance/banco/banco_tutors/banco_tutors';
// # Import transaction logs component
import TransactionLogs from '../../roles/admin/admin_tools/finance/transactions/transactions';

// # Import database components
import DatabaseView from '../../roles/admin/admin_tools/db/db_view';
import DbChapter from '../../roles/admin/admin_tools/db/db_chapter';

// # Import mentor and tech board components
import TechBoard from '../../roles/admin/admin_tools/tech_board/tech_board';
import OnCreateBoard from '../../roles/admin/admin_tools/tech_board/oncreate_board';
import LocksBoard from '../../roles/admin/admin_tools/tech_board/locks';
import SubscriptionBoard from '../../roles/admin/admin_tools/tech_board/subscription_board';
import UserBoard from '../../roles/admin/admin_tools/tech_board/user_board';
import OtherBoard from '../../roles/admin/admin_tools/tech_board/other_board';

// # Import under construction component
import UnderConstruction from '../../components/UnderConstruction';

// # Import shared components
import SharedHeader from '../../components/SharedHeader';
import DashboardFooter from '../../components/DashboardFooter';

// # Import mentor components
import MentorDashboard from '../../roles/admin/mentor/mentor';
import MentorCalendar from '../../roles/admin/mentor/sections/mentor_calendar';
import MentorMeetings from '../../roles/admin/mentor/sections/mentor_meetings';
import MenteesList from '../../roles/admin/mentor/sections/mentees_list';
import MySpace from '../../roles/admin/mentor/sections/my_space';

// # Import neo mentee components
import NeoMenteeStep1 from '../../neo_mentorship/neo_m_step1/neo_mentee_step1';
import NeoMenteeStep2 from '../../neo_mentorship/neo_m_step2/neo_mentee_step2';

// # Import content creation components
import Flowchart from '../../systems/content_create/flowchart/flowchart';
import AdminAssignments from '../../neo_mentorship/assigment_bank/adm_assignments';
import Marketing from '../../systems/marketing/marketing';
import MailMarketing from '../../systems/marketing/mail_marketing/mail_marketing';
import MarketingCalendar from '../../systems/marketing/markalendar/markalendar';
import SocialMarketing from '../../systems/marketing/social_marketing/social_marketing';
import MarketingPosts from '../../systems/marketing/marketing_posts/marketing_posts';
import MarketingDesigns from '../../systems/marketing/marketing_designs/marketing_designs';

// # Analytics Routes Component
const AnalyticsRoutes = () => (
  <Routes>
    <Route path="" element={
      <ProtectedRoute adminOnly={true}>
        <Analytics />
      </ProtectedRoute>
    } />
    <Route path="growth" element={
      <ProtectedRoute adminOnly={true}>
        <GrowthAnalytics />
      </ProtectedRoute>
    } />
    <Route path="activity" element={
      <ProtectedRoute adminOnly={true}>
        <ActivityAnalytics />
      </ProtectedRoute>
    } />
    <Route path="heatmap" element={
      <ProtectedRoute adminOnly={true}>
        <HeatMap />
      </ProtectedRoute>
    } />
    <Route path="subscriptions" element={
      <ProtectedRoute adminOnly={true}>
        <SubscriptionAnalytics />
      </ProtectedRoute>
    } />
    <Route path="technical" element={
      <ProtectedRoute adminOnly={true}>
        <TechnicalAnalytics />
      </ProtectedRoute>
    } />
    <Route path="auth" element={
      <ProtectedRoute adminOnly={true}>
        <AuthAnalytics />
      </ProtectedRoute>
    } />
  </Routes>
);

// # Financial Routes Component
const FinancialRoutes = () => {
  return (
    <Routes>
      <Route path="" element={
        <ProtectedRoute adminOnly={true}>
          <FinancialSystem />
        </ProtectedRoute>
      } />
      
      {/* Bank System Routes */}
      <Route path="bank">
        <Route index element={
          <ProtectedRoute adminOnly={true}>
            <Bank />
          </ProtectedRoute>
        } />
      </Route>
      
      {/* Banco Routes - New structure */}
      <Route path="banco">
        <Route path="account/:memberId" element={
          <ProtectedRoute adminOnly={true}>
            <BankAccount />
          </ProtectedRoute>
        } />
        <Route path="budget" element={
          <ProtectedRoute adminOnly={true}>
            <BudgetAccount />
          </ProtectedRoute>
        } />
        <Route path="tutors" element={
          <ProtectedRoute adminOnly={true}>
            <BancoTutors />
          </ProtectedRoute>
        } />
      </Route>

      <Route path="salary" element={
        <ProtectedRoute adminOnly={true}>
          <SalaryManagement />
        </ProtectedRoute>
      } />
      
      {/* Expenses System Routes */}
      <Route path="expenses">
        <Route index element={
          <ProtectedRoute adminOnly={true}>
            <ExpensesTracking />
          </ProtectedRoute>
        } />
        <Route path="register" element={
          <ProtectedRoute adminOnly={true}>
            <RegisterExpense />
          </ProtectedRoute>
        } />
        <Route path="history" element={
          <ProtectedRoute adminOnly={true}>
            <ExpenseHistory />
          </ProtectedRoute>
        } />
        <Route path="analytics" element={
          <ProtectedRoute adminOnly={true}>
            <ExpenseAnalytics />
          </ProtectedRoute>
        } />
      </Route>

      <Route path="revenue" element={
        <ProtectedRoute adminOnly={true}>
          <RevenueAnalytics />
        </ProtectedRoute>
      } />

      {/* Payment System Routes */}
      <Route path="payments">
        <Route index element={
          <ProtectedRoute adminOnly={true}>
            <PaymentProcessing />
          </ProtectedRoute>
        } />
        <Route path="register" element={
          <ProtectedRoute adminOnly={true}>
            <RegisterPayment />
          </ProtectedRoute>
        } />
        <Route path="history" element={
          <ProtectedRoute adminOnly={true}>
            <PaymentHistory />
          </ProtectedRoute>
        } />
        <Route path="analytics" element={
          <ProtectedRoute adminOnly={true}>
            <PaymentAnalytics />
          </ProtectedRoute>
        } />
        <Route path="transactions" element={
          <ProtectedRoute adminOnly={true}>
            <TransactionLogs />
          </ProtectedRoute>
        } />
      </Route>
      
      {/* Add transactions route at the financial level */}
      <Route path="transactions" element={
        <ProtectedRoute adminOnly={true}>
          <TransactionLogs />
        </ProtectedRoute>
      } />
      
      {/* Add a catch-all route to handle invalid sub-paths */}
      <Route path="*" element={
        <Navigate to="/admin/financial" replace />
      } />
    </Routes>
  );
};

// # Content Routes Component
const ContentRoutes = () => {
  const { step, chapterId } = useParams();
  
  return (
    <Routes>
      <Route path="" element={
        <ProtectedRoute adminOnly={true}>
          <MasterDatabase />
        </ProtectedRoute>
      } />
      <Route path=":step" element={
        <ProtectedRoute adminOnly={true}>
          <DatabaseView />
        </ProtectedRoute>
      } />
      <Route path=":step/:chapterId" element={
        <ProtectedRoute adminOnly={true}>
          <DbChapter />
        </ProtectedRoute>
      } />
      {/* Add a catch-all route to handle invalid paths */}
      <Route path="*" element={
        <Navigate to="/admin/content" replace />
      } />
    </Routes>
  );
};

// # Mentorship Routes Component
const MentorshipRoutes = () => {
  return (
    <Routes>
      {/* Mentor Dashboard and its sections */}
      <Route path="" element={
        <ProtectedRoute adminOnly={true}>
          <MentorDashboard />
        </ProtectedRoute>
      } />
      <Route path="calendar" element={
        <ProtectedRoute adminOnly={true}>
          <MentorCalendar />
        </ProtectedRoute>
      } />
      <Route path="meetings" element={
        <ProtectedRoute adminOnly={true}>
          <MentorMeetings />
        </ProtectedRoute>
      } />
      <Route path="mentees" element={
        <ProtectedRoute adminOnly={true}>
          <MenteesList />
        </ProtectedRoute>
      } />
      <Route path="study" element={
        <ProtectedRoute adminOnly={true}>
          <MySpace />
        </ProtectedRoute>
      } />

      {/* Neo Mentee Routes */}
      <Route path="step1/*" element={
        <ProtectedRoute adminOnly={true}>
          <NeoMenteeStep1 stepType="Step 1" isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="step2/*" element={
        <ProtectedRoute adminOnly={true}>
          <NeoMenteeStep2 stepType="Step 2" isAdmin={true} />
        </ProtectedRoute>
      } />

      {/* Add a catch-all route to handle invalid paths */}
      <Route path="*" element={
        <Navigate to="/admin/mentorship" replace />
      } />
    </Routes>
  );
};

// # Tech Board Routes Component
const TechBoardRoutes = () => {
  return (
    <Routes>
      <Route path="" element={
        <ProtectedRoute adminOnly={true}>
          <TechBoard />
        </ProtectedRoute>
      } />
      <Route path="oncreate" element={
        <ProtectedRoute adminOnly={true}>
          <OnCreateBoard />
        </ProtectedRoute>
      } />
      <Route path="locks" element={
        <ProtectedRoute adminOnly={true}>
          <LocksBoard />
        </ProtectedRoute>
      } />
      <Route path="subscriptions" element={
        <ProtectedRoute adminOnly={true}>
          <SubscriptionBoard />
        </ProtectedRoute>
      } />
      <Route path="users" element={
        <ProtectedRoute adminOnly={true}>
          <UserBoard />
        </ProtectedRoute>
      } />
      <Route path="other" element={
        <ProtectedRoute adminOnly={true}>
          <OtherBoard />
        </ProtectedRoute>
      } />
      {/* Add a catch-all route to handle invalid paths */}
      <Route path="*" element={
        <Navigate to="/admin/tech-board" replace />
      } />
    </Routes>
  );
};

// # Add SubscriptionRoutes component
const SubscriptionRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Subscriptions />} />
      <Route path="/management" element={<SubscriptionManagement />} />
      <Route path="/controls" element={<SubscriptionControls />} />
      <Route path="/special" element={<SpecialSubscription />} />
      <Route path="/logs" element={<SubscriptionLogs />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="*" element={
        <Navigate to="/admin/subscriptions" replace />
      } />
    </Routes>
  );
};

// # Add UserManagementRoutes component
const UserManagementRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Users />} />
      <Route path="/management" element={<UserManagement />} />
      <Route path="/admins-tutors" element={<AdminsTutors />} />
      <Route path="/mentees" element={<OurMentees />} />
      <Route path="/controls" element={<UsersControl />} />
      <Route path="/honors" element={<UserHonors />} />
      <Route path="*" element={
        <Navigate to="/admin/users" replace />
      } />
    </Routes>
  );
};

// # Add ContentCreationRoutes component
const ContentCreationRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <Navigate to="/admin/content-creation/flowchart" replace />
      } />
      <Route path="flowchart" element={
        <ProtectedRoute adminOnly={true}>
          <Flowchart />
        </ProtectedRoute>
      } />
      <Route path="assignments" element={
        <ProtectedRoute adminOnly={true}>
          <AdminAssignments />
        </ProtectedRoute>
      } />
      <Route path="marketing" element={
        <ProtectedRoute adminOnly={true}>
          <Marketing />
        </ProtectedRoute>
      } />
      <Route path="marketing/email" element={
        <ProtectedRoute adminOnly={true}>
          <MailMarketing />
        </ProtectedRoute>
      } />
      <Route path="marketing/calendar" element={
        <ProtectedRoute adminOnly={true}>
          <MarketingCalendar />
        </ProtectedRoute>
      } />
      <Route path="marketing/social" element={
        <ProtectedRoute adminOnly={true}>
          <SocialMarketing />
        </ProtectedRoute>
      } />
      <Route path="marketing/posts" element={
        <ProtectedRoute adminOnly={true}>
          <MarketingPosts />
        </ProtectedRoute>
      } />
      <Route path="marketing/designs" element={
        <ProtectedRoute adminOnly={true}>
          <MarketingDesigns />
        </ProtectedRoute>
      } />
      <Route path="*" element={
        <Navigate to="/admin/content-creation/flowchart" replace />
      } />
    </Routes>
  );
};

const AdminSecuredRoutes = () => {
  const location = useLocation();
  const path = location.pathname;

  // Extract the section from the path (e.g., /admin/analytics/growth -> analytics)
  const section = path.split('/')[2];

  // Return the appropriate component based on the section
  switch (section) {
    case 'analytics':
      return <AnalyticsRoutes />;
    case 'financial':
      return <FinancialRoutes />;
    case 'users':
      return <UserManagementRoutes />;
    case 'content':
      return <ContentRoutes />;
    case 'subscriptions':
      return <SubscriptionRoutes />;
    case 'content-creation':
      return <ContentCreationRoutes />;
    case 'feedback':
      return <AdminFeedback />;
    case 'support':
      return <SupportRequests />;
    case 'review-management':
      return <AdminReview />;
    case 'mentorship':
      return <MentorshipRoutes />;
    case 'tech-board':
      return <TechBoardRoutes />;
    default:
      // # Redirect to admin dashboard if route not found
      return <Navigate to="/admin" replace />;
  }
};

export default AdminSecuredRoutes;
